/** Loads the Google Maps JavaScript API once and caches the promise across callers. */

let loaderPromise = null;
let callbackCounter = 0;

export function loadGoogleMaps(apiKey) {
  if (window.google?.maps) return Promise.resolve(window.google.maps);
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    const callbackName = `__upsorokMapsLoaded${callbackCounter++}`;
    window[callbackName] = () => {
      delete window[callbackName];
      resolve(window.google.maps);
    };

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&loading=async&callback=${callbackName}`;
    script.async = true;
    script.onerror = () => {
      loaderPromise = null;
      reject(new Error("Couldn't load Google Maps."));
    };
    document.head.appendChild(script);
  });

  return loaderPromise;
}
